import { ReactNode } from "react";

const Count = ({
    children,
    count,
}: {
    children?: ReactNode;
    count: number;
}) => {
    return (
        <span className="flex w-14 items-center gap-1">
            {count}
            <span className="text-sm text-text-detail">txs</span>
            {children}
        </span>
    );
};

export default Count;
